import React, { useState, useEffect } from 'react';
import { useUnreadMessages } from '../../hooks/useUnreadMessages';
import { MessageSquare, X } from 'lucide-react';

export const MessageNotifier = () => {
  // 1. Listen to the real-time count from Firebase
  const totalUnread = useUnreadMessages();
  
  const [show, setShow] = useState(false);
  const [lastCount, setLastCount] = useState(0);

  useEffect(() => {
    // 🔔 TRIGGER: Only show if the count INCREASES (new message arrived)
    if (totalUnread > lastCount && totalUnread > 0) {
      setShow(true);
      
      // Play a subtle notification sound
      try {
        const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
        audio.volume = 0.5;
        audio.play().catch(() => {}); // Catch error if user hasn't interacted with page yet
      } catch (e) {}

      // Auto-hide after 5 seconds
      const timer = setTimeout(() => setShow(false), 5000);
      return () => clearTimeout(timer);
    }
    
    // Update our tracker
    setLastCount(totalUnread);
  }, [totalUnread, lastCount]);

  // Don't render anything if hidden or no messages
  if (!show) return null;

  return (
    // 🟢 CONTAINER: z-[9999] forces it to the very front. 
    // top-6 puts it just below the status bar area.
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] w-[90%] max-w-sm animate-in slide-in-from-top duration-500 pointer-events-none">
      
      {/* 🟢 BANNER: pointer-events-auto ensures you can click the X button */}
      <div className="bg-zinc-900 border border-green-500/40 rounded-2xl p-4 flex items-center gap-4 shadow-[0_10px_40px_rgba(0,0,0,0.8)] pointer-events-auto backdrop-blur-xl">
        
        {/* ICON */}
        <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-black shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.4)]">
          <MessageSquare size={20} fill="currentColor" />
        </div>
        
        {/* TEXT */}
        <div className="flex-1">
          <p className="text-white font-black text-sm uppercase italic tracking-wider">New Scoop</p>
          <p className="text-white/60 text-xs font-medium">
            You have {totalUnread} unread message{totalUnread > 1 ? 's' : ''}
          </p>
        </div>
        
        {/* CLOSE BUTTON */}
        <button 
          onClick={() => setShow(false)}
          className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/50 hover:text-white hover:bg-white/10 transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};